import React, { useState } from "react";

import { Link } from "react-router-dom";

import { motion } from "framer-motion";

import SEO from "../../components/SEO";

import AdSlot from "../../components/AdSlot";

import TiltCard from "../../components/TiltCard";

import { ToolIcon } from "../../lib/toolIcons";

import { tools, toolCategories } from "../../data/tools";

import { breadcrumbSchema, pageMeta } from "../../lib/seo";



const ToolsHub = () => {

  const [category, setCategory] = useState("all");



  const filtered =

    category === "all" ? tools : tools.filter((t) => t.category === category);



  return (

    <>

      <SEO

        title={pageMeta.tools.title}

        description={pageMeta.tools.description}

        keywords={pageMeta.tools.keywords}

        path={pageMeta.tools.path}

        jsonLd={breadcrumbSchema([

          { name: "Home", path: "/" },

          { name: "Daily Innovations", path: "/tools" },

        ])}

      />

      <div className="pt-28 pb-20 min-h-screen bg-dark-400 bg-mesh-gradient">

        <div className="section-container">

          <header className="text-center mb-10">

            <Link to="/#innovations" className="text-sm text-primary-400 hover:text-primary-300 mb-4 inline-block">

              ← Back to Home

            </Link>

            <h1 className="font-display text-4xl md:text-5xl font-bold gradient-text mb-4">

              Daily Innovations

            </h1>

            <p className="text-gray-400 max-w-2xl mx-auto">

              Free online tools — video downloaders, document converters, and utilities.

              Updated regularly by Purpose Labs to help you get things done faster, with no signup required.

            </p>

          </header>



          <AdSlot size="banner" className="mb-10 max-w-4xl mx-auto" />



          <nav aria-label="Tool categories" className="flex flex-wrap justify-center gap-2 mb-10">

            {toolCategories.map((cat) => (

              <button

                key={cat.id}

                onClick={() => setCategory(cat.id)}

                className={`px-5 py-2 rounded-xl text-sm font-medium transition-all ${

                  category === cat.id

                    ? "bg-primary-600 text-white"

                    : "glass-panel text-gray-400 hover:text-white"

                }`}

              >

                {cat.label}

              </button>

            ))}

          </nav>



          <section aria-label="Available tools" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">

            {filtered.map((tool, i) => (

              <motion.article

                key={tool.slug}

                initial={{ opacity: 0, y: 20 }}

                animate={{ opacity: 1, y: 0 }}

                transition={{ delay: i * 0.05 }}

              >

                <TiltCard glowColor={tool.color} className="h-full">

                  <Link

                    to={`/tools/${tool.slug}`}

                    className={`block h-full glass-panel-hover p-6 bg-gradient-to-br ${tool.gradient}`}

                  >

                    <ToolIcon slug={tool.slug} className="w-7 h-7 text-primary-400 mb-3" />

                    <h2 className="font-display font-bold text-white mb-2">{tool.title}</h2>

                    <p className="text-sm text-gray-400">{tool.description}</p>

                  </Link>

                </TiltCard>

              </motion.article>

            ))}

          </section>



          <AdSlot size="rectangle" className="mt-12 max-w-2xl mx-auto" />

        </div>

      </div>

    </>

  );

};



export default ToolsHub;

